import { css } from '@emotion/react'

export const formControlReset = css`
	appearance: none;
	border: none;
	background: none;
	margin: 0;
`
